// ======================================================================
// File Name       : QuestionAttributeDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import SelectBox from '../../components/SelectBox';
import { VALIDATE_TYPE, NUM_ATTRIBUTE_QUESTION_SEARCH_MAX } from '../../constants/index';
import FormControlValidate from '../FormControlValidate';
import RenderField from '../../utils/ReduxFormUtils';
import { createAttributeQuestionOptions, createAttributionList } from '../../utils/ContentQuestionUtils';

class QuestionAttributeDialog extends React.Component {
  render() {
    const {
      handleChangeOption,
      formValues,
      attributeOptions,
      attributeText,
      attributeListData,
      handleChangeTextAttribute,
      addAttribute,
      number,
      removeAttributeSearch,
      keyDelete,
    } = this.props;
    let isDisableAddAttribute = false;
    if (number === NUM_ATTRIBUTE_QUESTION_SEARCH_MAX) {
      isDisableAddAttribute = true;
    }
    let data = [{ name: null, value: null }];
    if (
      attributeListData &&
      attributeListData.allSecernIds &&
      attributeListData.allSecernIds.length &&
      attributeListData.bySecernId
    ) {
      data = createAttributeQuestionOptions(attributeListData.allSecernIds, attributeListData.bySecernId);
    }
    const userAttributeList = createAttributionList(number);
    const userAttributeView = userAttributeList.map((attribute, index) => {
      let valueSelectBox = '';
      let valueTextBox = '';
      if (attributeOptions && attribute && attributeOptions[attribute]) {
        valueSelectBox = attributeOptions[attribute];
      }
      if (attributeText && attribute && attributeText[attribute]) {
        valueTextBox = attributeText[attribute];
      }
      const keyOptions = 'attributeOptions';
      return (
        <Form.Group key={index} className="form-info">
          <Col as={Form.Label} sm={3} className="padding-attribute">
            検索属性{index + 1}
          </Col>
          <Col sm={3}>
            <SelectBox
              data={data}
              value={valueSelectBox}
              onChange={handleChangeOption}
              name={`${keyOptions}.${attribute}`}
            />
          </Col>
          <Col sm={3} className="padding-left-30">
            <FormControl
              type="text"
              name={attribute}
              disabled={valueSelectBox ? false : true}
              value={valueTextBox}
              onChange={handleChangeTextAttribute}
            />
          </Col>
          <Col as={Form.Label} sm={2}>
            { index > 4 &&
              <i
                role="button"
                onClick={() => {
                  removeAttributeSearch(`${keyDelete}.${attribute}`);
                }}
                className="bi bi-trash margin-top-10"
                name={`${keyDelete}.${attribute}`}
              />
            }
          </Col>
        </Form.Group>
      );
    });
    return (
      <div>{userAttributeView}
        <Form.Group className="form-info">
          <Col sm={7} className="padding-left-15 margin-bottom-10">
            <Button variant="primary" disabled={isDisableAddAttribute} onClick={addAttribute}>
            検索属性追加
            </Button>
          </Col>
        </Form.Group>
      </div>
    );
  }
}

export default QuestionAttributeDialog;
